import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router, RouterOutlet } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { ButtonLoaderComponent } from '../../../../shared/components/button-loader/button-loader.component';
import { ButtonComponent } from '../../../../shared/components/button/button.component';
import { StorageKeys } from '../../../../shared/enums/enums';
import { AuthService } from '../../../../shared/services/auth.service';
import { ProfileService } from '../../../../shared/services/profile.service';
import { StorageService } from '../../../../shared/services/storage.service';
import { SharedModule } from '../../../../shared/shared.module';

@Component({
  selector: 'app-login',
  standalone: true,
  templateUrl: './login.component.html',
  styleUrl: './login.component.scss',
  imports: [RouterOutlet, SharedModule, ButtonComponent, ButtonLoaderComponent],
})
export class LoginComponent implements OnInit {
  loginForm!: FormGroup;
  isLoading: boolean = false;
  showPassword: boolean = false;
  constructor(
    private fb: FormBuilder,
    private authService: AuthService,
    private storageService: StorageService,
    private router: Router,
    private toastr: ToastrService,
    private profileService: ProfileService
  ) {}
  ngOnInit(): void {
    this.init();
  }
  init() {
    this.loginForm = this.fb.group({
      email: [
        '',
        [
          Validators.required,
          Validators.pattern(
            /^\s*[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,4}\s*$/
          ),
        ],
      ],
      password: ['', [Validators.required]],
    });
  }
  onSignin() {
    try {
      if (!this.loginForm.valid) {
        this.loginForm.markAllAsTouched();
        return;
      }
      const { email, password } = this.loginForm.value;
      this.isLoading = true;
      this.authService.login(email.trim(), password).subscribe({
        next: (res) => {
          this.storageService.setItem(StorageKeys.authTokens, res);
          this.getProfile();
        },
        error: (err) => {
          this.isLoading = false;
          this.toastr.error(
            err?.error?.message || err?.message || 'Something went wrong!'
          );
        },
      });
    } catch (error) {}
  }

  getProfile() {
    this.profileService.fetchProfile().subscribe({
      next: (data) => {
        this.router.navigate(['/']);
        this.isLoading = false;
        this.profileService.setProfileDetails(data.profile);
      },
      error: (err) => {
        this.isLoading = false;
        this.toastr.error(
          err?.error?.message || err?.message || 'Something went wrong!'
        );
      },
    });
  }
}
